/**
 * El nombre del archivo, arriba de todo.
 *
 * Es un widget de bloque en la posición 0 y no un elemento aparte sobre el
 * editor: así vive DENTRO del scroll y se va de pantalla al bajar, como venía
 * haciendo en la vista previa. No es texto del documento —el `.md` no lo tiene
 * y nunca lo va a tener—, sólo una decoración más.
 *
 * Las decoraciones de bloque no las puede aportar un plugin de vista (ver
 * livePreview.ts), así que ésta va como valor directo del facet: el título no
 * cambia dentro de un mismo estado, y `load()` crea uno nuevo por documento.
 */

import { Decoration, EditorView, WidgetType } from "@codemirror/view";
import { type Extension } from "@codemirror/state";

class TitleWidget extends WidgetType {
  constructor(private title: string) {
    super();
  }
  eq(other: TitleWidget): boolean {
    return other.title === this.title;
  }
  toDOM(): HTMLElement {
    const el = document.createElement("div");
    el.className = "cm-doc-title";
    el.textContent = this.title;
    return el;
  }
  /** Clickear el título pone el cursor al principio, no se come el click. */
  ignoreEvent(): boolean {
    return false;
  }
}

export function docTitle(title: string): Extension {
  return EditorView.decorations.of(
    Decoration.set([
      Decoration.widget({ widget: new TitleWidget(title), block: true, side: -1 }).range(0),
    ]),
  );
}
